'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('AdminSupervisorReviewControllers')

.factory('adminSupervisorReviewService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/Administration/AccessReview/API';

    //HttpGet
    service.getSupervisorsSystemsAndSysRoles = function () {
        return $http.get(baseUrl + '/GetSupervisorsSystemsAndSysRoles')
                    .then(function (response) {
                        return response.data;
                    });
    }

    // HttpPost
    service.submitSupervisorReminder = function (emailContent, supervisorId) {
        return $http.post(baseUrl + '/SubmitSupervisorReminder',
                          {
                              emailContent: emailContent,
                              supervisorId: supervisorId
                          });
    }


    service.createAdditionalAccessReview = function (accessReviewId, supervisorId) {
        return $http.post(baseUrl + '/CreateAdditionalAccessReview',
                          {
                              AdditionalAccessReviewID: accessReviewId,
                              SupervisorId:supervisorId
                          });
    }

    return service;

}]);
